import Rates from '../components/rates/Rates';

const Template = {
  template: '<router-view></router-view>',
};

export default {
  path: '/rates',
  component: Template,
  children: [
    {
      path: '',
      name: 'Rates',
      component: Rates,
      meta: {
        title: 'Rates - Mod24',
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/ratesRoutes.js